import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_DownOutlined = _resolveComponent("DownOutlined");
  var _component_a_menu_item = _resolveComponent("a-menu-item");
  var _component_a_menu = _resolveComponent("a-menu");
  var _component_a_dropdown = _resolveComponent("a-dropdown");
  return _openBlock(), _createBlock(_component_a_dropdown, {
    trigger: ['click']
  }, {
    overlay: _withCtx(function () {
      return [_createVNode(_component_a_menu, {
        onClick: $setup.languageChange
      }, {
        "default": _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.langMap, function (value, key) {
            return _openBlock(), _createBlock(_component_a_menu_item, {
              key: key,
              disabled: _ctx.$i18n.locale === key
            }, {
              "default": _withCtx(function () {
                return [_createTextVNode(_toDisplayString(value), 1)];
              }),
              _: 2
            }, 1032, ["disabled"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["onClick"])];
    }),
    "default": _withCtx(function () {
      return [_createElementVNode("a", {
        "class": "main-text-color",
        style: _normalizeStyle($props.styles),
        onClick: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["prevent"]))
      }, [_createTextVNode(_toDisplayString($setup.langMap[_ctx.$i18n.locale]) + " ", 1), _createVNode(_component_DownOutlined)], 4)];
    }),
    _: 1
  });
}